import { computed, inject, ref } from 'vue';
import { useSiteConfig } from './useSiteConfig';
import { getTurnstileApi } from '../utils/loadTurnstile';
export const CHECKOUT_TURNSTILE_KEY = Symbol('checkoutTurnstile');
export function createCheckoutTurnstile() {
    const { siteConfig } = useSiteConfig();
    const widgetId = ref('');
    const loadError = ref('');
    const hasToken = ref(false);
    const siteKey = computed(() => siteConfig.value?.security?.turnstileSiteKey?.trim() || '');
    const isEnabled = computed(() => Boolean(siteKey.value));
    const isReady = computed(() => !isEnabled.value || hasToken.value);
    const getToken = () => {
        const turnstile = getTurnstileApi();
        if (!widgetId.value || !turnstile)
            return '';
        return turnstile.getResponse(widgetId.value) || '';
    };
    const reset = () => {
        hasToken.value = false;
        const turnstile = getTurnstileApi();
        if (!widgetId.value || !turnstile)
            return;
        turnstile.reset(widgetId.value);
    };
    const markSolved = () => {
        hasToken.value = true;
    };
    return {
        siteKey,
        isEnabled,
        isReady,
        loadError,
        widgetId,
        getToken,
        reset,
        markSolved,
        setLoadError: (message) => {
            loadError.value = message;
        },
        clearLoadError: () => {
            loadError.value = '';
        }
    };
}
export function useCheckoutTurnstile() {
    const context = inject(CHECKOUT_TURNSTILE_KEY);
    if (!context) {
        throw new Error('useCheckoutTurnstile() requires provide(CHECKOUT_TURNSTILE_KEY) in CheckoutPage');
    }
    return context;
}
